import './lib/evaluation'
import './lib/mount'
import Vue from 'vue'
import IconInstall from './install'

Vue.use(IconInstall)
